import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root',
})
export class CourseService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadCoursesApi() {
		return this.ngrxService.loadInitAPI('course', 'list');
	}

	loadCourseDataApi() {
		return this.getCourseList().pipe(
			map(data => {
				this.ngrxService.loadInitData('course', 'list', data);
			}),
		);
	}

	fetchCourseData() {
		return this.ngrxService.loadData('course', 'list');
	}

	getCourseList() {
		return this.http.get(environment.url.catalog + '/course/list/all/v2');
	}
}
